import ApiService from "@/common/api.service";
import {
  FETCH_SPARE_PART_TYPES,
  FETCH_SPARE_PART_TYPE,
  UPDATE_SPARE_PART_TYPE,
  CREATE_SPARE_PART_TYPE,
  RESET_SPARE_PART_TYPE,
  DELETE_SPARE_PART_TYPE
} from "../actions.type";
import {
  FETCH_SPARE_PART_TYPE_START,
  SET_SPARE_PART_TYPES,
  SET_SPARE_PART_TYPE
} from "../mutations.type";

const state = {
  sparePartTypes: [],
  sparePartTypesCount: 1,
  sparePartType: {},
  isLoading: false
};

const getters = {
  sparePartTypesCount: state => state.sparePartTypesCount,
  sparePartTypes: state => state.sparePartTypes,
  sparePartType: state => state.sparePartType,
  sparePartTypeIsLoading: state => state.isLoading
};

const actions = {
  [FETCH_SPARE_PART_TYPES]({ commit }, [filteringCriteria, search]) {
    commit(FETCH_SPARE_PART_TYPE_START);
    return ApiService.filteredCollection(
      "spare-part-types",
      filteringCriteria,
      search
    ).then(({ data }) => {
      commit(SET_SPARE_PART_TYPES, data);
    });
  },
  [FETCH_SPARE_PART_TYPE](context, id) {
    return ApiService.get("spare-part-types", id).then(({ data }) => {
      context.commit(SET_SPARE_PART_TYPE, data);
    });
  },
  [UPDATE_SPARE_PART_TYPE](context, payload) {
    return ApiService.put(`spare-part-types/${payload.id}`, payload);
  },
  [CREATE_SPARE_PART_TYPE](context, payload) {
    return ApiService.post("spare-part-types", payload);
  },
  [RESET_SPARE_PART_TYPE](context) {
    context.commit(SET_SPARE_PART_TYPE, {});
  },
  [DELETE_SPARE_PART_TYPE](context, id) {
    return ApiService.delete("spare-part-types", id);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_SPARE_PART_TYPE_START](state) {
    state.isLoading = true;
  },
  [SET_SPARE_PART_TYPES](state, data) {
    state.sparePartTypes = data.items || [];
    state.sparePartTypesCount = data.total || 1;
    state.isLoading = false;
  },
  [SET_SPARE_PART_TYPE](state, data) {
    state.sparePartType = data;
    state.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
